import { useCallback, useEffect, useMemo, useState } from "react";
var useScreenSize = function () {
    var _a = useState(0), height = _a[0], setHeight = _a[1];
    var _b = useState(0), width = _b[0], setWidth = _b[1];
    var updateWidth = useCallback(function () {
        setWidth(Math.max(window.innerWidth, document.documentElement.clientWidth));
    }, []);
    var updateHeight = useCallback(function () {
        setHeight(Math.max(window.innerHeight, document.documentElement.clientHeight));
    }, []);
    useEffect(function () {
        updateWidth();
        updateHeight();
        window.addEventListener("resize", function () {
            updateWidth();
            updateHeight();
        });
    }, [updateWidth, updateHeight]);
    var _c = useMemo(function () {
        /**
         * Screen size exactly 16:9
         */
        if (width / height === 16 / 9) {
            return [width, height];
        }
        /**
         * If screen are longer than 16:9
         */
        if (width / height > 16 / 9) {
            return [width, width * (9 / 16)];
        }
        return [height * (16 / 9), height];
    }, [height, width]), videoWidth = _c[0], videoHeight = _c[1];
    return { height: height, width: width, video: { width: videoWidth, height: videoHeight } };
};
export default useScreenSize;
//# sourceMappingURL=useScreenSize.js.map